module.exports = __webpack_public_path__ + "static/media/greenhouseStep7-1.8d1fb171.jpg";